interface TaskDossierMenuActions {
  view: () => void
  edit: () => void
  activityLog: () => void
  delete: () => void
}

interface TaskDossierMenuOption {
  label: string
  gate: boolean
  icon: string
  bg_color?: string
  txt_color?: string
  action: () => void
}

/** Options of the "…" menu of a task (BaseDropDownMenu sections), shared by the card and the list row. */
export const taskDossierMenuOptions = (
  translate: (key: string) => string,
  actions: TaskDossierMenuActions
): TaskDossierMenuOption[][] => [
  [
    {
      label: translate('button.view'),
      gate: true,
      icon: 'eye',
      action: actions.view
    },
    {
      label: translate('button.edit'),
      gate: true,
      icon: 'edit',
      action: actions.edit
    },
    {
      label: translate('global.activity_log'),
      gate: true,
      icon: 'clock',
      action: actions.activityLog
    }
  ],
  [
    {
      label: translate('button.delete'),
      gate: true,
      icon: 'trash',
      bg_color: 'bg-gradient-to-b from-red-600 to-red-700',
      txt_color: 'text-white',
      action: actions.delete
    }
  ]
]
